import React from "react";
import PropTypes from "prop-types";

import { Checkbox, FormControlLabel } from "@mui/material";

const MbWay = ({ mbwayEnabled, onChange }) => {
  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={mbwayEnabled}
          onChange={onChange}
          name="mbway_enabled"
          color="primary"
        />
      }
      label="Organization accepts MB WAY on the Membrz Eupago account"
    />
  );
};

MbWay.propTypes = {
  mbwayEnabled: PropTypes.bool,
  onChange: PropTypes.func,
};

export default MbWay;
